import { menuItems } from '@lib/constants/sidemenu/fib-sidemenu.constants';
import { Theme } from '../theme.interface';
import { FibHomeComponent } from '@pages/home/components/fib-home/fib-home.component';
import { SendMoneyComponent } from '@pages/send-money/tenant6/send-money.component';

export const fibConfig: Theme = {
    name: 'fibConfig',
    properties: {
        '--font-family': '29LT Bukra',
        '--primary-color': '#6CBF00',
        '--primary-color-light': '#86BC25',
        '--border-radius': '0.5rem',
        '--heading-font-size': '2rem',
    },
    assets: {
        clientName: 'Fawry',
        otpFieldStyle: 'input-otp-box',
        loginSvg: 'assets/fib/login.svg',
        logoSvg: 'assets/fib/logo.svg',
        sideMenu: menuItems,
        loginFlow: 'password',
        homeComponent: FibHomeComponent,
        allowedCountriesInPhoneSearch: ['sd'],
        loginLayoutColumnLeft: 'col-lg-6',
        loginLayoutColumnRight: 'col-lg-6',
        sendMoneyComponent: SendMoneyComponent,
        favicon: 'assets/fib/favicon.ico',
    },
};
